import moment from 'moment'

class Callbacks {
  static getEmptyFormHandler(user_id) {
    return function getEmptyForm() {
      return {
        createdAt: moment().format(),
        operator: user_id
      }
    }
  }
  static filterToFormHandler() {
    return function filterToForm(filter) {
      return {
        ...filter
      }
    }
  }
  static filterToStateHandler() {
    return function filterToState(state) {
      return {
        ...state
      }
    }
  }
  static formToFilterHandler(record_id) {
    return function formToFilter(values, extra, meta, state) {
      return {
        driver: record_id
      }
    }
  }
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        ...record
      }
    }
  }

  static formToRecordHandler(record_id) {
    return function formToRecord(values, extra, meta) {
      return {
        reason: _.get(values, 'reason'),
        operator: _.get(values, 'operator'),
        driver: record_id,
        service: _.get(values, 'service.companyservice_id')
      }
    }
  }
}

export default Callbacks
